import { environment } from 'src/environments/environment';

const URL_LOGS_QA = 'https://wsqa.polpaicoconexion.cl/api/logs/eventos';
const URL_LOGS_PROD = 'https://ws.polpaicoconexion.cl/api/logs/eventos';

/** URL absoluta del endpoint POST /api/logs/eventos según el build. */
export function getLogsGatewayUrl(): string {
  return environment.production ? URL_LOGS_PROD : URL_LOGS_QA;
}

/** True si la URL pertenece al API de logs (p. ej. POST /api/logs/eventos). */
export function isLogsGatewayRequest(url: string): boolean {
  return url.includes('/api/logs/');
}

export { isMonitoringGatewayRequest } from './url.store-forward.gateway';
